<div class="package-signed-route">

  <ng-template [ngIf]="signingPackageSignedParam$ | async"
               [ngIfElse]="notSigned">
    <h1 i18n>Merci</h1>

    <p i18n>
      Merci d'avoir signé. Vous recevrez un email de confirmation.
    </p>
    <p i18n>
      Nous vous contacterons lorsque vos polices seront en gestion effective chez LifeisLife.
    </p>
    <p i18n>
      Vous pouvez maintenant fermer cette page
    </p>
  </ng-template>
  <ng-template #notSigned>
    <ng-template [ngIf]="signingPackageRejectedParam$ | async"
                 [ngIfElse]="notSignedNotRejected">

      <h1 i18n>Merci</h1>

      <p i18n>
        Nous avons bien pris note de votre refus. Nous vous contacterons prochainement.
      </p>

      <p i18n>
        Vous pouvez maintenant fermer cette page
      </p>

    </ng-template>
    <ng-template #notSignedNotRejected>
      <h1 i18n>Merci</h1>

      <p i18n>
        Merci d'avoir signé. Vous recevrez un email de confirmation.
      </p>

      <p i18n>
        Vous pouvez maintenant fermer cette page
      </p>
    </ng-template>
  </ng-template>

  <div class="actions">
    <a [routerLink]="['/products']">
      Mes produits LifeisLife
    </a>
  </div>

</div>
